<div class="dark-stripe">
    <div class="w-full h-full flex align-items-center justify-content-center">
        <img src="/assets/logo/logo-st-w-footer.png">
        <h2>CRM</h2>
        <small>v.0.0.9</small>
    </div>
</div>

<div class="login-container">
    <div class="graphic-element-vertical"></div>
    <div class="login-box">
        
        <div class="logo-mobile w-full h-full flex align-items-center justify-content-center">
            <img src="/assets/logo/logo-st-vector-completo-small.png">
            <small>CRM</small>
            <!-- <small>v.0.0.9</small> -->
        </div>

        <h2 class="text-center">Login</h2>
        <div class="muted-r-bg alert-in-page mb-3" *ngIf="login_error">
            <div class="flex align-items-center gap-3">
                <img src="/assets/imgs/alert-g.png" width="40">
                <div class="flex flex-column gap-1">
                    <strong>Si è verificato un errore</strong>
                    <small>{{err_message}}</small>
                </div>
            </div>
        </div>
        <form [formGroup]="frmLogin" (ngSubmit)="login()">
            <div>
                <label>E-mail</label>
                <input type="text" pInputText formControlName="email" class="w-full">
                <st-errors *ngIf="frmLogin.get('email')?.errors && frmLogin.get('email')?.touched"
                    [errors]="frmLogin.get('email')?.errors"></st-errors>
            </div>
            <div class="mt-3">
                <label>Password</label>
                <input type="password" pInputText formControlName="password" class="w-full">
                <st-errors *ngIf="frmLogin.get('password')?.errors && frmLogin.get('password')?.touched"
                    [errors]="frmLogin.get('password')?.errors"></st-errors>
            </div>
            <div class="mt-5">
                <p-button label="Accedi" size="small" styleClass="slide px-6" [disabled]="frmLogin.invalid"
                    type="submit"></p-button>
            </div>
        </form>
    </div>

    <div class="graphic-element"></div>

</div>